import {
  Identify,
  identify,
  init,
  reset,
  track,
  setUserId,
} from "@amplitude/analytics-browser"
import Hotjar from "@hotjar/browser"

import { isVercelDeployment } from "../constants"

export const ANALYTIC_EVENTS = {
  AI_GENERATE: "ai_generate_message",
  AI_NEXT: "ai_next_suggestion",
  AI_PREV: "ai_previous_suggestion",
  AI_PICK: "ai_pick_suggestion",
  AI_SEND: "ai_send_message",
  AI_CLOSE: "ai_close_suggestions",
  AI_ERROR: "ai_generate_error",

  ADD_SCHEDULED_MESSAGE: "add_scheduled_message",
  ADD_QUEST: "add_quest",
  VIEW_CLIENT_TAB: "view_client_tab", // params { tab }
  OPEN_ADD_SCHEDULED_MESSAGE: "open_add_scheduled_message", // params { source }
  SHOW_COACH_BOOKING_PAGE: "show_coach_booking_page", // params { link_type }

  MARK_SESSION_AS_NO_SHOW: "mark_session_no-show",
  MARK_SESSION_AS_LATE_CANCEL: "mark_session_latecancellation",
  RESCHEDULE_COACH_SESSION: "reschedule_coach_session",
  CANCEL_COACH_SESSION: "cancel_coach_session",
  MAKEUP_COACH_SESSION: "makeup_coach_session",
  SCHEDULE_COACH_SESSION: "schedule_coach_session",
  MARK_SESSION_AS_MODAL: "mark_session_as_modal",
  POST_SESSION_FLOW_GENERATE_NOTE: "post-session-flow_generate-note",
  MARK_SESSION_COMPLETED: "mark_session_completed",
  POST_SESSION_FLOW_SCHEDULE_NEXT_SESSION:
    "post-session-flow_schedule-next-session",
  POST_SESSION_FLOW_SEND_CLIENT_SUMMARY:
    "post-session-flow_send-client-summary",
  POST_SESSION_FLOW_TRY_AGAIN_AI_NOTE: "post-session-flow_try-again-AI-note",
  POST_SESSION_FLOW_WRITE_SUMMARY_MANUALLY:
    "post-session-flow_write-summary-manually",
}

if (import.meta.env.PROD && !isVercelDeployment) {
  // Initialize amplitude
  init(import.meta.env.VITE_AMPLITUDE_API_KEY as string, undefined, {
    minIdLength: 1,
  })
  // Initialize hotjar
  Hotjar.init(3623886, 6)
}

export function analyticsUserDidLogin(userId: string) {
  // User id
  setUserId(userId)
  // User properties
  const event = new Identify()
  identify(event)
}

export function analyticsUserDidLogout() {
  reset()
}

export function trackAnalyticEvent(
  eventName: string,
  eventParams: { [param: string]: any } = {}
) {
  if (import.meta.env.DEV || isVercelDeployment) return
  eventParams.platform = "web_coach"
  track(eventName, eventParams)
}
